import React from "react";
import "./style/about-intro.css";
import AboutButton from "../atoms/about-button";
import "../atoms/style/button.css";

function AboutIntro() {
	return (
		<div className="intro-container">
			<div className="paragraph">
				<h2 className="header-title">Botta Gioielli</h2>
				<p className="header-text">
					Botta Gioielli brand is owned by Nicola Botta since 1998 for the
					creation of luxury jewels. <br />
					Botta Gioielli is now involved in marketing not only its creations but
					also selected antique jewels.
				</p>

				<AboutButton />
			</div>
		</div>
	);
}

export default AboutIntro;
